import { initializeApp, getApps, getApp } from "firebase/app";
import type { FirebaseApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { initializeAnalytics, isSupported } from "firebase/analytics";
import type { Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBghsB1Dd6KnlKR93XZN5QRPq6Aml7Mo0s",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "leo-delivery-4fa15.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "leo-delivery-4fa15",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "leo-delivery-4fa15.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "43359676760",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:43359676760:web:d4239d8e582a3438101d2d",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-QETXC088BY",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://leo-delivery-4fa15-default-rtdb.firebaseio.com"
};

// Initialize Firebase
const isConfigValid = !!firebaseConfig.apiKey && !!firebaseConfig.projectId;
const isAnalyticsEnabled = process.env.REACT_APP_FIREBASE_ANALYTICS_ENABLED !== "false";

var app: FirebaseApp | null = null;
if (isConfigValid) {
  try {
    app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
  } catch (error) {
    console.error("Firebase initialization error:", error);
  }
}

export var db = app ? getFirestore(app) : null as any;
export var rtdb = (app && firebaseConfig.databaseURL) ? getDatabase(app) : null as any;

let analyticsPromise: Promise<Analytics | null> | null = null;

export const getFirebaseAnalytics = (): Promise<Analytics | null> => {
  const firebaseApp = app;

  if (!firebaseApp || !firebaseConfig.measurementId || !isAnalyticsEnabled) {
    return Promise.resolve(null);
  }

  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => supported ? initializeAnalytics(firebaseApp, {
        config: {
          send_page_view: false,
        },
      }) : null)
      .catch((error) => {
        console.error("Firebase Analytics initialization error:", error);
        return null;
      });
  }

  return analyticsPromise;
};

export default app;
